import _ from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {AppState} from '../../../../../store/appState';
import {getTopics} from '../../../../../store/data/topics/topicsSelectors';
import {ConversationSummaryReferencePreviewers} from './conversationSummaryReferencePreviewers';

/*
 * Props.
 */

interface ConversationSummaryReferencePreviewersContainerProps {
  conversation: ConversationModel;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: ConversationSummaryReferencePreviewersContainerProps) {
  return props.conversation;
}

function makeGetConversationTopics() {
  return createSelector([getConversation, getTopics], (conversation, topics) =>
    _(conversation.topicIds)
      .map((topicId) => topics[topicId])
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationSummaryReferencePreviewersContainerProps>()(() => ({
  topics: makeGetConversationTopics(),
}));

export const ConversationSummaryReferencePreviewersContainer = connect(mapStateToProps)(
  ConversationSummaryReferencePreviewers,
);
